import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[appPhoneMask]',
})
export class PhoneMaskDirective {
  constructor(
    private el: ElementRef<HTMLInputElement>,
  ) {
  }

  @HostListener('input', ['$event'])
  onInput(): void {
    const input = this.el.nativeElement;
    let value = input.value.replace(/\D/g, '');

    if (value.startsWith('27')) {
      value = value.slice(2);
    } else if (value.startsWith('0')) {
      value = value.slice(1);
    }

    // apply pattern: +27 __ ___ ____
    let formatted = '+27 ';
    if (value.length > 0) formatted += value.substring(0, 2);
    if (value.length >= 3) formatted += ' ' + value.substring(2, 5);
    if (value.length >= 6) formatted += ' ' + value.substring(5, 9);

    input.value = formatted.trim();
  }
}
